import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "form-details" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "form-title" }, [
        /*#__PURE__*/ _createElementVNode("h2", null, "\r\n\t\t\t\t\tReports\r\n\t\t\t\t")
    ]),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("div", { class: "form-menu" }, [
        /*#__PURE__*/ _createElementVNode("div", { class: "float-end" })
    ])
], -1 /* HOISTED */);
const _hoisted_3 = { class: "form-contents" };
const _hoisted_4 = { class: "col-sm-12 col-md-2 ps-0" };
const _hoisted_5 = { class: "x_panel" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("div", { class: "x_title report-list-title" }, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "m-0" }, "Type")
], -1 /* HOISTED */);
const _hoisted_7 = { class: "x_content p-0 mt-0" };
const _hoisted_8 = { class: "report-list-options" };
const _hoisted_9 = ["onClick"];
const _hoisted_10 = { style: { "margin-top": "8px" } };
const _hoisted_11 = ["onClick"];
const _hoisted_12 = { class: "icon-badge-container" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("i", {
    class: "fa fa-clock-o fa-2x",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
const _hoisted_14 = ["title"];
const _hoisted_15 = { class: "col-xs-12 col-sm-12 col-md-10 pe-0 ps-0" };
const _hoisted_16 = { class: "x_panel" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("div", { class: "x_title" }, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "m-0" }, "Description")
], -1 /* HOISTED */);
const _hoisted_18 = ["innerHTML"];
const _hoisted_19 = { class: "x_panel" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("div", { class: "x_title" }, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "m-0" }, "Parameters")
], -1 /* HOISTED */);
const _hoisted_21 = { class: "x_content mt-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DashboardReportFilterVue = _resolveComponent("DashboardReportFilterVue");
    const _component_DischargeReportFilterVue = _resolveComponent("DischargeReportFilterVue");
    const _component_OhmicTrendReportFilterVue = _resolveComponent("OhmicTrendReportFilterVue");
    const _component_DischargeActivityReportFilterVue = _resolveComponent("DischargeActivityReportFilterVue");
    const _component_StringLifeReportFilterVue = _resolveComponent("StringLifeReportFilterVue");
    const _component_BlockStatusReportFilterVue = _resolveComponent("BlockStatusReportFilterVue");
    const _component_StringStatusReportFilterVue = _resolveComponent("StringStatusReportFilterVue");
    const _component_CompanySummaryReportFilterVue = _resolveComponent("CompanySummaryReportFilterVue");
    const _component_SiteIssueSummaryReportFilterVue = _resolveComponent("SiteIssueSummaryReportFilterVue");
    const _component_CompanySystemsReportFilterVue = _resolveComponent("CompanySystemsReportFilterVue");
    const _component_BatteryReplacementEstimationReportFilterVue = _resolveComponent("BatteryReplacementEstimationReportFilterVue");
    const _component_ReportSchedulerManagerVue = _resolveComponent("ReportSchedulerManagerVue");
    const _component_ReportSchedulerWizardVue = _resolveComponent("ReportSchedulerWizardVue");
    const _directive_standard_or_higher = _resolveDirective("standard-or-higher");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (item) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    class: _normalizeClass(['report-list-option', _ctx.isActive(item) ? 'active' : '']),
                                    onClick: ($event) => (_ctx.selectReportItem(item))
                                }, [
                                    _createElementVNode("div", _hoisted_10, _toDisplayString(item.reportName), 1 /* TEXT */),
                                    _createTextVNode(),
                                    _withDirectives((_openBlock(), _createElementBlock("div", {
                                        onClick: _withModifiers(($event) => (_ctx.openReportScheduleManager(item)), ["stop"])
                                    }, [
                                        _createElementVNode("div", _hoisted_12, [
                                            _hoisted_13,
                                            _createTextVNode(),
                                            (item.numberOfScheduledReports > 0)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: "icon-badge",
                                                    title: _ctx.getNumberOfScheduledReportsTitle(item)
                                                }, _toDisplayString(_ctx.getNumberOfScheduledReports(item)), 9 /* TEXT, PROPS */, _hoisted_14))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ], 8 /* PROPS */, _hoisted_11)), [
                                        [_directive_standard_or_higher]
                                    ])
                                ], 10 /* CLASS, PROPS */, _hoisted_9));
                            }), 256 /* UNKEYED_FRAGMENT */))
                        ])
                    ])
                ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createTextVNode(),
                    _createElementVNode("div", {
                        class: "x_content mt-0",
                        innerHTML: _ctx.reportDescription
                    }, null, 8 /* PROPS */, _hoisted_18)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_21, [
                        (_ctx.isParameterVisible(1))
                            ? (_openBlock(), _createBlock(_component_DashboardReportFilterVue, {
                                key: _ctx.componentKey,
                                onSchedule: _ctx.schedule,
                                onUpdateSchedule: _ctx.updateSchedule,
                                reportScheduledModel: _ctx.reportScheduleModelToEdit
                            }, null, 8 /* PROPS */, ["onSchedule", "onUpdateSchedule", "reportScheduledModel"]))
                            : _createCommentVNode("v-if", true),
                        _createTextVNode(),
                        (_ctx.isParameterVisible(2))
                            ? (_openBlock(), _createBlock(_component_DischargeReportFilterVue, {
                                key: _ctx.componentKey,
                                onSchedule: _ctx.schedule,
                                onUpdateSchedule: _ctx.updateSchedule,
                                reportScheduledModel: _ctx.reportScheduleModelToEdit
                            }, null, 8 /* PROPS */, ["onSchedule", "onUpdateSchedule", "reportScheduledModel"]))
                            : _createCommentVNode("v-if", true),
                        _createTextVNode(),
                        (_ctx.isParameterVisible(3))
                            ? (_openBlock(), _createBlock(_component_OhmicTrendReportFilterVue, {
                                key: _ctx.componentKey,
                                onSchedule: _ctx.schedule,
                                onUpdateSchedule: _ctx.updateSchedule,
                                reportScheduledModel: _ctx.reportScheduleModelToEdit
                            }, null, 8 /* PROPS */, ["onSchedule", "onUpdateSchedule", "reportScheduledModel"]))
                            : _createCommentVNode("v-if", true),
                        _createTextVNode(),
                        (_ctx.isParameterVisible(4))
                            ? (_openBlock(), _createBlock(_component_DischargeActivityReportFilterVue, {
                                key: _ctx.componentKey,
                                onSchedule: _ctx.schedule,
                                onUpdateSchedule: _ctx.updateSchedule,
                                reportScheduledModel: _ctx.reportScheduleModelToEdit
                            }, null, 8 /* PROPS */, ["onSchedule", "onUpdateSchedule", "reportScheduledModel"]))
                            : _createCommentVNode("v-if", true),
                        _createTextVNode(),
                        (_ctx.isParameterVisible(5))
                            ? (_openBlock(), _createBlock(_component_StringLifeReportFilterVue, {
                                key: _ctx.componentKey,
                                onSchedule: _ctx.schedule,
                                onUpdateSchedule: _ctx.updateSchedule,
                                reportScheduledModel: _ctx.reportScheduleModelToEdit
                            }, null, 8 /* PROPS */, ["onSchedule", "onUpdateSchedule", "reportScheduledModel"]))
                            : _createCommentVNode("v-if", true),
                        _createTextVNode(),
                        (_ctx.isParameterVisible(6))
                            ? (_openBlock(), _createBlock(_component_BlockStatusReportFilterVue, {
                                key: _ctx.componentKey,
                                onSchedule: _ctx.schedule,
                                onUpdateSchedule: _ctx.updateSchedule,
                                reportScheduledModel: _ctx.reportScheduleModelToEdit
                            }, null, 8 /* PROPS */, ["onSchedule", "onUpdateSchedule", "reportScheduledModel"]))
                            : _createCommentVNode("v-if", true),
                        _createTextVNode(),
                        (_ctx.isParameterVisible(7))
                            ? (_openBlock(), _createBlock(_component_StringStatusReportFilterVue, {
                                key: _ctx.componentKey,
                                onSchedule: _ctx.schedule,
                                onUpdateSchedule: _ctx.updateSchedule,
                                reportScheduledModel: _ctx.reportScheduleModelToEdit
                            }, null, 8 /* PROPS */, ["onSchedule", "onUpdateSchedule", "reportScheduledModel"]))
                            : _createCommentVNode("v-if", true),
                        _createTextVNode(),
                        (_ctx.isParameterVisible(8))
                            ? (_openBlock(), _createBlock(_component_CompanySummaryReportFilterVue, {
                                key: _ctx.componentKey,
                                onSchedule: _ctx.schedule,
                                onUpdateSchedule: _ctx.updateSchedule,
                                reportScheduledModel: _ctx.reportScheduleModelToEdit
                            }, null, 8 /* PROPS */, ["onSchedule", "onUpdateSchedule", "reportScheduledModel"]))
                            : _createCommentVNode("v-if", true),
                        _createTextVNode(),
                        (_ctx.isParameterVisible(9))
                            ? (_openBlock(), _createBlock(_component_SiteIssueSummaryReportFilterVue, {
                                key: _ctx.componentKey,
                                onSchedule: _ctx.schedule,
                                onUpdateSchedule: _ctx.updateSchedule,
                                reportScheduledModel: _ctx.reportScheduleModelToEdit
                            }, null, 8 /* PROPS */, ["onSchedule", "onUpdateSchedule", "reportScheduledModel"]))
                            : _createCommentVNode("v-if", true),
                        _createTextVNode(),
                        (_ctx.isParameterVisible(10))
                            ? (_openBlock(), _createBlock(_component_CompanySystemsReportFilterVue, {
                                key: _ctx.componentKey,
                                onSchedule: _ctx.schedule,
                                onUpdateSchedule: _ctx.updateSchedule,
                                reportScheduledModel: _ctx.reportScheduleModelToEdit
                            }, null, 8 /* PROPS */, ["onSchedule", "onUpdateSchedule", "reportScheduledModel"]))
                            : _createCommentVNode("v-if", true),
                        _createTextVNode(),
                        (_ctx.isParameterVisible(11))
                            ? (_openBlock(), _createBlock(_component_BatteryReplacementEstimationReportFilterVue, {
                                key: _ctx.componentKey,
                                onSchedule: _ctx.schedule,
                                onUpdateSchedule: _ctx.updateSchedule,
                                reportScheduledModel: _ctx.reportScheduleModelToEdit
                            }, null, 8 /* PROPS */, ["onSchedule", "onUpdateSchedule", "reportScheduledModel"]))
                            : _createCommentVNode("v-if", true)
                    ])
                ])
            ])
        ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.loaded]
        ]),
        _createTextVNode(),
        _createVNode(_component_ReportSchedulerManagerVue, {
            ref: "reportSchedulerManager",
            onEditScheduledReportFilter: _ctx.editScheduledReportFilter,
            onUpdateCount: _ctx.updateCount
        }, null, 8 /* PROPS */, ["onEditScheduledReportFilter", "onUpdateCount"]),
        _createTextVNode(),
        _createVNode(_component_ReportSchedulerWizardVue, {
            ref: "reportSchedulerWizard",
            onUpdateCount: _ctx.updateCount
        }, null, 8 /* PROPS */, ["onUpdateCount"])
    ]));
}
